import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type RefreshAuthTokenMutationVariables = Types.Exact<{
  refreshToken: Types.Scalars['String']
  clientTabId?: Types.InputMaybe<Types.Scalars['String']>
  userId?: Types.InputMaybe<Types.Scalars['Int']>
  userRole?: Types.InputMaybe<Types.UserRoles>
}>

export type RefreshAuthTokenMutation = {
  __typename?: 'Mutation'
  refreshAuthToken: {
    __typename?: 'RotatedAuthSession'
    token: string
    refreshToken: string
    refreshTokenReceipt: string
  }
}

export const RefreshAuthTokenDocument = gql`
  mutation RefreshAuthToken(
    $refreshToken: String!
    $clientTabId: String
    $userId: Int
    $userRole: UserRoles
  ) {
    refreshAuthToken(
      refreshToken: $refreshToken
      clientTabId: $clientTabId
      userId: $userId
      userRole: $userRole
    ) {
      token
      refreshToken
      refreshTokenReceipt
    }
  }
`
export type RefreshAuthTokenMutationFn = ApolloReactCommon.MutationFunction<
  RefreshAuthTokenMutation,
  RefreshAuthTokenMutationVariables
>
export function useRefreshAuthTokenMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RefreshAuthTokenMutation,
    RefreshAuthTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<RefreshAuthTokenMutation, RefreshAuthTokenMutationVariables>(
    RefreshAuthTokenDocument,
    options
  )
}
export type RefreshAuthTokenMutationHookResult = ReturnType<typeof useRefreshAuthTokenMutation>
export type RefreshAuthTokenMutationResult =
  ApolloReactCommon.MutationResult<RefreshAuthTokenMutation>
export type RefreshAuthTokenMutationOptions = ApolloReactCommon.BaseMutationOptions<
  RefreshAuthTokenMutation,
  RefreshAuthTokenMutationVariables
>
